import { render, staticRenderFns } from "./ProductAvailabilityInfo.vue?vue&type=template&id=dd587bfe&"
import script from "./ProductAvailabilityInfo.vue?vue&type=script&lang=js&"
export * from "./ProductAvailabilityInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProductAvailabilityInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports